module.exports = __webpack_public_path__ + "img/home-124226884.b17d78c8.jpg";